import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '❓ ¿Para qué tipo de profesional está pensado?',
    answer: 'Para psicólogos, terapeutas ocupacionales, fonoaudiólogos, psicopedagogos y cualquier profesional de la salud que trabaje estimulación cognitiva con pacientes de distintas edades. No necesitás especialización previa en neuropsicología para usarlo.'
  }, {
    question: '❓ ¿Funciona para pacientes con diagnóstico o solo para prevención?',
    answer: 'Para los dos. El Módulo I y el Módulo II están diseñados específicamente para deterioro cognitivo leve y moderado respectivamente. El Módulo III es para prevención y envejecimiento saludable. Cada módulo tiene fichas calibradas para ese perfil clínico específico.'
  }, {
    question: '❓ ¿Tengo que imprimir todo o puedo usarlo en pantalla?',
    answer: 'Podés hacer las dos cosas. Las fichas de trabajo están diseñadas para imprimir. El Protocolo de Ingreso, el Planificador y la Guía de Alertas podés usarlos en pantalla o imprimir solo lo que necesitás para cada paciente.'
  }, {
    question: '❓ ¿Para qué rango de edad sirven los módulos principales?',
    answer: 'Los 4 módulos clínicos principales están diseñados para pacientes de 60 a 90 años. Los Súper Bonos amplían el sistema a adolescentes de 12 a 18 años y adultos de 20 a 50 años.'
  }, {
    question: '❓ ¿Puedo usarlo con pacientes que ya tengo en tratamiento?',
    answer: 'Sí. Podés entrar al módulo que corresponde al nivel de tu paciente actual y empezar desde las fichas que mejor se ajusten a su momento clínico. No necesitás empezar desde cero con cada paciente.'
  }, {
    question: '❓ ¿Cuánto tiempo tarda en implementarse?',
    answer: 'Desde el día uno. Comprás el viernes, el lunes lo estás usando en sesión. No hay curva de aprendizaje. Las fichas tienen instrucciones clínicas integradas.'
  }, {
    question: '❓ ¿Qué pasa si compro y no me sirve?',
    answer: 'Garantía de 7 días. Te devolvemos todo sin preguntas.'
  }];
  return <section className="py-16 sm:py-24 bg-gray-50" data-id="element-93">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-95">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-12 text-center" data-id="element-96">
            PREGUNTAS FRECUENTES
          </h2>

          <div className="space-y-4" data-id="element-97">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.05
          }} className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-98">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors" data-id="element-99">
                  <span className="text-lg font-semibold text-gray-900 pr-4" data-id="element-100">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-6 h-6 text-teal-600 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-101" />
                </button>

                <AnimatePresence data-id="element-102">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-103">
                      <div className="px-6 pb-5 text-gray-700 leading-relaxed" data-id="element-104">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}